module.exports = __webpack_public_path__ + "static/media/firma-alvaro.fcef09e7.png";